import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class ProposalService extends BaseService {
  getCountProposal(
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `draftorder/count_draft_order`
    ).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getProposal(
    search: string,
    status: number,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `draftorder/list_draft_order?Search=${search}&offset=0&limit=100&status=${status}`
    ).subscribe(
      (resp) => {
        // const r = {
        //   "alert": {
        //     "code": 417,
        //     "message": "ToP Anda telah diupdate",
        //     "inner_message": ""
        //   },
        //   data: []
        // }

        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getProposalDetail(
    param: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`draftorder/${param}`).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  approvalProposal(
    param: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const query = `NoTransaksi=${param.NoTransaksi}&CustCode=${param.CustCode}&Response=${param.Response}&Reason=${param.Reason}&PurchaseOrderNumber=${param.PurchaseOrderNumber}`

    const formData = new FormData();
    formData.append('File', param.Files);

    this.postMultipartFormData(`draftorder/ezView_Command?${query}`, formData).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }
}
